module.exports = __webpack_public_path__ + "static/img/cd5f54400a79aec3a69ceb2355f96jpeg.53dcd5f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cd5f54400a79aec3a69ceb2355f96jpeg.jpeg
// module id = 70
// module chunks = 2